/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TokenBurner, TokenBurnerInterface } from "../TokenBurner";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "BURN_ADDRESS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "startId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "endId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "targetToken",
        type: "address",
      },
    ],
    name: "batchBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "destroy",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class TokenBurner__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TokenBurner> {
    return super.deploy(overrides || {}) as Promise<TokenBurner>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): TokenBurner {
    return super.attach(address) as TokenBurner;
  }
  connect(signer: Signer): TokenBurner__factory {
    return super.connect(signer) as TokenBurner__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TokenBurnerInterface {
    return new utils.Interface(_abi) as TokenBurnerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TokenBurner {
    return new Contract(address, _abi, signerOrProvider) as TokenBurner;
  }
}
